module.exports = __webpack_public_path__ + "pics_title.7b258949.png";